import styles from "../Carousel.module.css";
import type { CarouselSubProps } from "../types";

const { slide } = styles;

export const Slide = ({ children, ratio }: CarouselSubProps) => {
  if (!children) return null;

  return (
    <li className={slide} data-ratio={ratio}>
      {children}
    </li>
  );
};
